import { ChangeDetectionStrategy, Component, computed, ViewEncapsulation } from '@angular/core';
import { SpecialComponent } from '@src/suite/common/controls/special/special';
import { selectTranslatedKey } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { i18nKeys } from '@src/suite/common/utils/i18n.default';

@Component({
    selector: 'st-special-cost',
    templateUrl: './special-cost.html',
    styleUrls: ['./special-cost.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-special-cost',
    },
})
export class SpecialCostComponent extends SpecialComponent {
    costColumnLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(i18nKeys.PSTWebCostColumnLabel))();
    });

    costTypeColumnLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(i18nKeys.PSTWebCostTypeColumnLabel))();
    });

    public calculateEditable(i: number): boolean {
        return !this.internalValue()?.get(i, 0) || !!this.disabled();
    }
}
